import React from 'react';

const ReplayContext = React.createContext({
    gpsPlayer: null,
    onClose: null,
    mapMarker: null
});

export default ReplayContext;